<modal [title]="title" [tagEventImp]="tagEventImp" [tagEventCTA]="tagEventCTA" [tagEventClose]="tagEventClose">
    <p>Vous êtes connecté à un compte qui ne vous permet pas de finaliser votre commande.</p>
    <p>Veuillez vous deconnecter et créer un nouveau compte ou connectez-vous à un compte autorisé.</p>

    <ng-template #customModalFooter>
        <div class="buttons">
            <button class="button is-conversion" (click)="logout()">Se deconnecter</button>
            <button class="button is-conversion" (click)="close()">Terminer</button>
        </div>
    </ng-template>
</modal>
